'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = require('./SvgIcon');

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Zendesk = (_temp = _class = function (_SvgIcon) {
  _inherits(Zendesk, _SvgIcon);

  function Zendesk() {
    _classCallCheck(this, Zendesk);

    return _possibleConstructorReturn(this, (Zendesk.__proto__ || Object.getPrototypeOf(Zendesk)).apply(this, arguments));
  }

  _createClass(Zendesk, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'linearGradient',
            {
              id: 'linear-gradient',
              x1: '268.92',
              y1: '-238.81',
              x2: '291.61',
              y2: '92.03',
              gradientTransform: 'translate(-0.23 360.26)',
              gradientUnits: 'userSpaceOnUse'
            },
            _react2['default'].createElement('stop', { offset: '0', stopColor: '#90b91b' }),
            _react2['default'].createElement('stop', { offset: '0.51', stopColor: '#85b017' }),
            _react2['default'].createElement('stop', { offset: '1', stopColor: '#6f9d10' })
          ),
          _react2['default'].createElement('linearGradient', {
            id: 'linear-gradient-2',
            x1: '316.93',
            y1: '-242.08',
            x2: '339.71',
            y2: '90.18',
            href: '#linear-gradient'
          }),
          _react2['default'].createElement('linearGradient', {
            id: 'linear-gradient-3',
            x1: '315.64',
            y1: '-242.01',
            x2: '338.33',
            y2: '88.84',
            href: '#linear-gradient'
          }),
          _react2['default'].createElement('linearGradient', {
            id: 'linear-gradient-4',
            x1: '257.69',
            y1: '-238.04',
            x2: '280.37',
            y2: '92.79',
            href: '#linear-gradient'
          }),
          _react2['default'].createElement('linearGradient', {
            id: 'linear-gradient-5',
            x1: '159.84',
            y1: '-231.34',
            x2: '182.53',
            y2: '99.5',
            href: '#linear-gradient'
          }),
          _react2['default'].createElement('linearGradient', {
            id: 'linear-gradient-6',
            x1: '87.49',
            y1: '-226.37',
            x2: '110.18',
            y2: '104.46',
            href: '#linear-gradient'
          }),
          _react2['default'].createElement('linearGradient', {
            id: 'linear-gradient-7',
            x1: '90.36',
            y1: '-226.57',
            x2: '113.05',
            y2: '104.3',
            href: '#linear-gradient'
          }),
          _react2['default'].createElement('linearGradient', {
            id: 'linear-gradient-8',
            x1: '134.16',
            y1: '-233.4',
            x2: '157.29',
            y2: '103.93',
            href: '#linear-gradient'
          }),
          _react2['default'].createElement('linearGradient', {
            id: 'linear-gradient-9',
            x1: '183.69',
            y1: '-232.96',
            x2: '206.38',
            y2: '97.88',
            href: '#linear-gradient'
          }),
          _react2['default'].createElement('linearGradient', {
            id: 'linear-gradient-10',
            x1: '135.52',
            y1: '-229.3',
            x2: '158.16',
            y2: '100.94',
            href: '#linear-gradient'
          }),
          _react2['default'].createElement('path', {
            fill: 'url(#linear-gradient)',
            d: 'M334.6,234.8a99.89,99.89,0,0,1-48.7,12.8,83.38,83.38,0,0,1-30.4-5.4,228.38,228.38,0,0,1-43,30,96.74,96.74,0,0,0,58.7,42.5,94.31,94.31,0,0,0,23.4,2.9,101.85,101.85,0,0,0,48.2-12.4A98.69,98.69,0,0,0,334.6,234.8Z'
          }),
          _react2['default'].createElement('path', {
            fill: 'url(#linear-gradient-2)',
            d: 'M318,112.9c-1.2-.3-2.3-0.8-3.4-1.1v0.1A33.74,33.74,0,0,0,318,112.9Z'
          }),
          _react2['default'].createElement('path', {
            fill: 'url(#linear-gradient-3)',
            d: 'M314.5,112.8c-2.9,19.5-11.3,36.8-23.1,49.6a64.51,64.51,0,0,1,1,11.1c0,22.8-11.8,42.5-26.5,58.5a106.57,106.57,0,0,0,12.6.8,96.85,96.85,0,0,0,59.8-20.6A98.73,98.73,0,0,0,374.9,150c-13.9-18.3-34.3-31.3-57-37-1.2-.3-2.3-0.7-3.5-0.9Z'
          }),
          _react2['default'].createElement('path', {
            fill: 'url(#linear-gradient-4)',
            d: 'M299,96.1A97.63,97.63,0,0,0,272.5,29h-1.4c-23.2,0-43.5,8.2-61.9,24.9,17.6,18.7,23.9,42.4,23.9,66.1,0,1.9-.1,3.8-0.1,5.7a49.12,49.12,0,0,1,11.9-1.5h1c15.1,0.3,30.4,7.8,39.1,22A96,96,0,0,0,299,96.1Z'
          }),
          _react2['default'].createElement('path', {
            fill: 'url(#linear-gradient-5)',
            d: 'M124.1,30.7a9.33,9.33,0,0,1-3.3-.3A97,97,0,0,0,95.5,95.8a2.22,2.22,0,0,1-.1.9h3.3a97.26,97.26,0,0,1,68.4,27.7c14.5,1,29.4,8.7,37.2,24,4.2-8.2,10.4-14.2,17-17.3v-3.4a97,97,0,0,0-97-97h-0.2Z'
          }),
          _react2['default'].createElement('path', {
            fill: 'url(#linear-gradient-6)',
            d: 'M151.3,125.8a96.9,96.9,0,0,0-48.9-13.3A99.65,99.65,0,0,0,85.3,114a97.87,97.87,0,0,0-61.4,37.9A96.78,96.78,0,0,0,60,212.8c14.6-19.5,35-32.2,56.1-36.2v-3.1C116,147,132.5,130.6,151.3,125.8Z'
          }),
          _react2['default'].createElement('path', {
            fill: 'url(#linear-gradient-7)',
            d: 'M65.9,235a96.43,96.43,0,0,0-11.4,45.4,110.07,110.07,0,0,0,3.3,26.3,97.24,97.24,0,0,0,46.6,11.9,102.41,102.41,0,0,0,23.7-2.9,100,100,0,0,1-3.6-26.4,98.87,98.87,0,0,1,18.3-57.2c-11.3-12.2-20.8-26.5-24.7-42.8A97,97,0,0,0,65.9,235Z'
          }),
          _react2['default'].createElement('path', { fill: 'url(#linear-gradient-8)', d: 'M148.1,325.26h0l-1.1.5h0Z' }),
          _react2['default'].createElement('path', {
            fill: 'url(#linear-gradient-9)',
            d: 'M200.6,375.4A96.67,96.67,0,0,0,251,325.5a97.07,97.07,0,0,1-52.5-51.9c-7.9-4.1-28.5-15.6-47.1-32.8a96.91,96.91,0,0,0-10.8,44.6,94.39,94.39,0,0,0,8.5,39.5A98.64,98.64,0,0,0,200.6,375.4Z'
          }),
          _react2['default'].createElement('path', { fill: 'url(#linear-gradient-10)', d: 'M149.1,324.9l-1,.5h0Z' }),
          _react2['default'].createElement('path', {
            fill: '#6f9d10',
            d: 'M288,251.9a98.75,98.75,0,0,0,48.5-12.7c-0.7-1.5-1.3-3.1-2.1-4.6a99.89,99.89,0,0,1-48.7,12.8,83.38,83.38,0,0,1-30.4-5.4,228.38,228.38,0,0,1-43,30c0.9,1.4,1.9,2.8,2.9,4.1,9.1-5,26.3-15.2,42.3-29.6A83.92,83.92,0,0,0,288,251.9Z'
          }),
          _react2['default'].createElement('path', {
            fill: '#6f9d10',
            d: 'M314.5,111.7v0.1c1.2,0.2,2.3.7,3.5,0.9A29.23,29.23,0,0,1,314.5,111.7Z'
          }),
          _react2['default'].createElement('path', {
            fill: '#6f9d10',
            d: 'M293.4,166.8c11.8-12.9,20.2-30.2,23.1-49.6l0.1-.8v-0.14c1.2,0.3,2.3.8,3.4,1.1a103.77,103.77,0,0,1,54.5,34.1l0.3-1.5c-13.9-18.2-34.3-31.3-57-37a35.77,35.77,0,0,0-3.5-.9l-0.1.8c-2.9,19.5-11.3,36.8-23.1,49.6a64.51,64.51,0,0,1,1,11.1c0,22.8-11.8,42.5-26.5,58.5,1.9,0.2,3.9.2,5.8,0.4,12.9-15.2,22.8-33.5,22.9-54.3A50.21,50.21,0,0,0,293.4,166.8Z'
          }),
          _react2['default'].createElement('path', {
            fill: '#6f9d10',
            d: 'M273.2,33.4h1.4a97.81,97.81,0,0,1,14.9,20.86,96.86,96.86,0,0,0-17.1-25.4H271c-23.2,0-43.5,8.2-61.9,24.9,1.1,1.2,2.1,2.5,3.1,3.7C230.4,41.4,250.4,33.4,273.2,33.4Z'
          }),
          _react2['default'].createElement('path', {
            fill: '#6f9d10',
            d: 'M224.9,77.8c5.8,13.3,8.2,27.7,8.2,42.1,0,1.9-.1,3.8-0.1,5.7a18.46,18.46,0,0,1,2.3-.4v-0.7C235.2,108.26,232.2,92.26,224.9,77.8Z'
          }),
          _react2['default'].createElement('path', {
            fill: '#6f9d10',
            d: 'M122.9,34.8a9.33,9.33,0,0,0,3.3.3,96.51,96.51,0,0,1,87,54A97,97,0,0,0,124,30.6a9,9,0,0,1-3.3-.3A97,97,0,0,0,95.4,95.7a2.22,2.22,0,0,1-.1.9h2.47A95.91,95.91,0,0,1,122.9,34.8Z'
          }),
          _react2['default'].createElement('path', {
            fill: '#6f9d10',
            d: 'M26,156.2a97.83,97.83,0,0,1,78.5-39.4,96.44,96.44,0,0,1,42.6,10.1c1.4-.5,2.7-1,4.1-1.4a96.9,96.9,0,0,0-48.9-13.3,99.65,99.65,0,0,0-17.1,1.5,97.87,97.87,0,0,0-61.43,37.9,95.87,95.87,0,0,0,9.4,28.4A96.44,96.44,0,0,1,26,156.2Z'
          }),
          _react2['default'].createElement('path', {
            fill: '#6f9d10',
            d: 'M142.6,232a115.87,115.87,0,0,1-17.7-24.5,109.28,109.28,0,0,0,16.9,25.6A4.44,4.44,0,0,0,142.6,232Z'
          }),
          _react2['default'].createElement('path', {
            fill: '#6f9d10',
            d: 'M68,239.4a96.69,96.69,0,0,1,51.3-45.3c-0.5-1.6-1-3.2-1.4-4.8a97.66,97.66,0,0,0-63.5,91.1,110.73,110.73,0,0,0,3.3,26.3c0.4,0.2.9,0.4,1.3,0.6a109.2,109.2,0,0,1-2.5-22.5A96.55,96.55,0,0,1,68,239.4Z'
          }),
          _react2['default'].createElement('path', { fill: '#6f9d10', d: 'M146.9,325.7h0l1.1-.5h0Z' }),
          _react2['default'].createElement('path', {
            fill: '#6f9d10',
            d: 'M249.6,328.2a24.37,24.37,0,0,0,1.4-2.8A97.29,97.29,0,0,1,202.6,282,96.87,96.87,0,0,0,249.6,328.2Z'
          }),
          _react2['default'].createElement('path', {
            fill: '#6f9d10',
            d: 'M153.5,245.2a227,227,0,0,0,47.1,32.7c-0.7-1.5-1.5-3-2.1-4.5-7.9-4.1-28.5-15.6-47.1-32.8a96.91,96.91,0,0,0-10.8,44.6,94.39,94.39,0,0,0,8.5,39.5c0.6,1.3,1.3,2.5,1.9,3.7A97.68,97.68,0,0,1,153.5,245.2Z'
          }),
          _react2['default'].createElement('path', { fill: '#6f9d10', d: 'M147.9,325.2l1-.5-1,.5h0Z' })
        );
      }

      return render;
    }()
  }]);

  return Zendesk;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 399.75 400.17'
}, _temp);
exports['default'] = Zendesk;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/SvgIcon/Zendesk.js
// module id = 1418
// module chunks = 32